
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/ccpa",
      function () {
        return require("private-next-pages/support/ccpa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/ccpa"])
      });
    }
  